import { gql } from '__generated__'

export const GetCandidateForClientProfile = gql(/* GraphQL */ `
    query GetRosterCandidateForClientProfile($rosterCandidateId: ID!) {
        rosterCandidate(rosterCandidateId: $rosterCandidateId) {
            id
            clientFavorites {
                createdAt
                updatedAt
                id
                client {
                    user {
                        firstName
                        nickname
                        lastName
                    }
                }
            }
            roster {
                rosterName
                id
                candidateProcessStatusGroupSummary {
                    statusSummaryGroup {
                        label
                        summaryGroup
                    }
                }
            }

            candidateProcessStatus {
                createdByUser {
                    firstName
                    lastName
                }
                processStatus {
                    statusLabel
                }
                isActive
                createdAt
            }
            candidateProcessStatusHistory {
                createdAt
                updatedByUser {
                    firstName
                    lastName
                    nickname
                }
                updatedAt
                rosterCandidateId
                processStatus {
                    statusLabel
                    processStatusSummaryGroup {
                        label
                        summaryGroup
                    }
                }
            }
            externalRecruiterNote {
                id
                note
                createdByUser {
                    preferredName
                    id
                }
                updatedByUser {
                    preferredName
                    id
                }
                createdAt
                updatedAt
            }
            clientFavorites {
                createdAt
                updatedAt
                id
                client {
                    user {
                        firstName
                        nickname
                        lastName
                    }
                }
            }
            candidate {
                id
                internalProfileImageKey
                user {
                    lastName
                    firstName
                    nickname
                    email
                    phone
                    preferredName
                    profileImageKey
                }
                currentWorkExperience {
                    company {
                        value
                    }
                    title {
                        value
                    }
                    sectors {
                        sector {
                            value
                        }
                    }
                    industries {
                        industry {
                            value
                        }
                    }
                    companyOffice {
                        officeLocation {
                            value
                        }
                    }
                }
                analystClassYear
                linkedinUrl
                bio {
                    bio
                }
                documents {
                    documentKey
                    documentType
                    id
                }
                internalProfileImageKey
                workExperience {
                    isCurrent
                    industries {
                        topTier
                        industry {
                            value
                        }
                    }
                    sectors {
                        sector {
                            value
                        }
                        topTier
                    }
                    title {
                        value
                    }
                    company {
                        value
                    }
                    startDate
                    companyOffice {
                        officeLocation {
                            value
                        }
                    }
                }
                education {
                    graduationDate
                    college {
                        isActive
                        value
                    }
                }
                startYear
            }
        }
    }
`)

export const CreateRosterCandidateClientNote = gql(/* GraphQL */ `
    mutation AddRosterCandidateClientNote(
        $rosterCandidateId: ID!
        $note: String!
        $rating: Float
    ) {
        addRosterCandidateClientNote(
            rosterCandidateId: $rosterCandidateId
            note: $note
            starRating: $rating
        ) {
            success
            message
        }
    }
`)
